import { RootState } from '@app/redux/root-reducer';

export const selectAddClientState = (store: RootState) => store.clientsReducer.addClient;
export const selectClientState = (store: RootState) => store.clientsReducer.clients;
export const selectUpdateClientState = (store: RootState) => store.clientsReducer.updateClient;
export const selectUpdateClientStatusState = (store: RootState) =>
  store.clientsReducer.updateClientStatus;
export const selectClientDetailsState = (store: RootState) => store.clientsReducer.clientDetails;
export const selectClientDetailsByIdState = (store: RootState) =>
  store.clientsReducer.clientDetailsById;
